import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function SystemIntro() {
  const topics = ['Técnica', 'Progresión', 'Planificación', 'Táctica', 'Grupos', 'Negocio', 'Físico', 'Fidelización', 'Comunicación', 'Mentalidad', 'Gestión', 'Metodología'];
  const profiles = ['Principiante', 'Intermedio', 'Avanzado', 'Competencia', 'Grupos', 'Individual', 'Adultos', 'Niños', 'Juvenil', 'Recreativo', 'Alto Rendimiento', 'Entrenador Independiente'];
  return <section className="py-12 md:py-20 bg-navy-900 text-white relative overflow-hidden" data-id="element-289">
      <div className="absolute inset-0 bg-court-pattern opacity-30" data-id="element-290"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-291">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-292">
          <p className="text-optic font-bold tracking-widest uppercase text-xs md:text-sm mb-3 md:mb-4" data-id="element-293">
            Sistema N°1 para entrenadores de tenis en Argentina
          </p>
          <h2 className="text-2xl md:text-5xl font-display mb-4 md:mb-6" data-id="element-294">
            RECURSOSFITNESS™ MEGAPACK —{' '}
            <span className="text-terracotta" data-id="element-295">SISTEMA COMPLETO</span>
          </h2>
          <p className="text-base md:text-2xl text-gray-300 font-medium mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-296">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </p>

          <div className="inline-block bg-white/10 border border-white/20 rounded-xl p-4 md:p-6 mb-8 md:mb-12 backdrop-blur-sm" data-id="element-297">
            <p className="text-lg md:text-2xl font-bold text-white mb-1 md:mb-2" data-id="element-298">
              +360 páginas de contenido estructurado
            </p>
            <p className="text-sm md:text-lg text-optic" data-id="element-299">
              60+ recursos completos listos para usar
            </p>
          </div>
        </motion.div>

        <div className="mb-10 md:mb-16" data-id="element-300">
          <div className="flex flex-wrap justify-center gap-1.5 md:gap-2 max-w-4xl mx-auto" data-id="element-301">
            {topics.map((topic, i) => <span key={i} className="px-2.5 py-1 md:px-3 md:py-1.5 bg-navy-800 text-gray-300 rounded-md text-xs md:text-sm font-medium border border-navy-700" data-id="element-302">
                {topic}
              </span>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-800/80 border border-navy-700 rounded-2xl p-5 md:p-10 text-left" data-id="element-303">
          <div className="flex flex-col md:flex-row gap-5 md:gap-8 items-center" data-id="element-304">
            <div className="md:w-1/3 text-center md:text-left" data-id="element-305">
              <h3 className="text-lg md:text-2xl font-display text-white mb-2 md:mb-4" data-id="element-306">
                Funciona desde hoy mismo en tu club, academia o espacio
                independiente.
              </h3>
              <p className="text-sm md:text-base text-gray-400" data-id="element-307">
                Niveles y perfiles incluidos:
              </p>
            </div>
            <div className="md:w-2/3 grid grid-cols-2 sm:grid-cols-3 gap-2 md:gap-3" data-id="element-308">
              {profiles.map((profile, i) => <div key={i} className="flex items-center gap-2" data-id="element-309">
                  <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-optic flex-shrink-0" data-id="element-310" />
                  <span className="text-xs md:text-sm text-gray-300 font-medium" data-id="element-311">
                    {profile}
                  </span>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}